<template>
  <Modal
    ref="modal"
    @opened="onOpened"
    @closed="onClosed"
  >
    <div class="building-info-wrapper">
      <div class="building-info-inner">
        <article class="building-info">
          <div class="building-info-image-wrapper">
            <img
              class="building-info-image"
              :src="currentBuilding.thumbnail"
              :alt="currentBuilding.name"
            >
          </div>
          <div
            v-show="currentBuilding.advertiseLink"
            class="building-info-icon-wrapper"
          >
            <a
              class="building-info-icon-a"
              :href="setAdvertiseLinkHref"
              target="_blank"
            >
              <i class="building-info-icon isif isif-foreign" />
            </a>
          </div>
          <hr class="building-info-hr">
          <pre class="building-info-desc pre-custom">{{ currentBuilding.descriptionMulti[lang] || currentBuilding.description }}</pre>
        </article>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from '../../../IModal/index'
export default {
  name: 'ModalBuildingInfo',
  components: {
    Modal
  },
  data () {
    return {
      lang: this.$i18n.locale
    }
  },
  computed: {
    ...mapGetters([
      'currentBuilding'
    ]),

    modalState () {
      if (this.$refs.modal) {
        return this.$refs.modal.visible
      }
      return false
    },

    setAdvertiseLinkHref () {
      const advertiseLink = this.currentBuilding.advertiseLink
      return /^https?:\/\//.test(advertiseLink)
        ? `${advertiseLink}`
        : `https://${advertiseLink}`
    }
  },

  methods: {
    show () {
      this.$refs.modal.show()
    },

    hide () {
      this.$refs.modal.hide()
    },
    onOpened () {
      this.$emit('opened')
    },
    onClosed () {
      this.$emit('closed')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main';
@import '~css/common/br-extends';

.building-info-wrapper {
  position: absolute;
  top: 0;
  left: 0
  right: 0
  margin: auto
  margin-top: 3.875rem;
  padding: 0.9375rem 0;
  width: calc(100% - 2.5rem)
  height: 52.7093%;
  max-width: 708px
  background-color: alpha($br-background-color, 90%)
  border-radius: 2px;

  @media (min-width: $response) {
    margin-top: 7.375rem;
    padding: 1.25rem 0 1.875rem;
    height: 64.1666%;
    box-shadow: 0 0 8px 0 rgba($black, 0.5);
  }
}

.building-info-inner {
  height: 100%;
  padding: 0 0.9375rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  @media (min-width: $response) {
    padding: 0 1.875rem;
  }
}

.building-info-image-wrapper {
  display: none;
  justify-content: center;

  @media (min-width: $response) {
    display: flex;
  }
}

.building-info-image {
  max-width: 338px;
  height: 169px;
  object-fit: cover;
}

.building-info-hr {
  margin: 5px 0;
  opacity: 0;
  border: 0;

  @media (min-width: $response) {
    opacity: 0.5;
    border: solid 1px rgba($white, 0.5);
    margin: 1.25rem 0;
  }
}

$pd = 0.5rem;
.building-info-icon-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  @media (min-width: $response) {
    height: 0;

    .building-info-icon {
      transform: translateY(-100%) translate($pd, $pd);
    }
  }
}

a.building-info-icon-a {
  @media (min-width: $response) {
    &:hover,
    &:active {
      color: inherit;
    }

    &:hover {
      .building-info-icon {
        border-radius: 5px;
        background-color: rgba(88, 88, 90, 0.6);
      }
    }
  }
}

.building-info-icon {
  display: inline-flex;
  font-size: 1.25rem;

  @media (min-width: $response) {
    padding: $pd;
    font-size: 1.5rem;
  }
}

.building-info {

  @media (min-width: $response) {
    line-height: 1.875rem;
  }
}

.building-info-desc {
  word-break: break-word;
  letter-spacing: 1px;
  line-height: 1.5;
  @extends .br-description
}
</style>
